var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "div",
        {
          staticClass: "table-overlay",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              _vm.isActive = false
            },
          },
        },
        [
          _c("div", { staticClass: "container-table" }, [
            _c("h4", {
              domProps: { innerHTML: _vm._s(_vm.params.title || "Undefined") },
            }),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.params.subTitle || "Undefined"),
              },
            }),
            _vm.tables.length > 1
              ? _c(
                  "div",
                  { staticClass: "nav" },
                  _vm._l(_vm.tables, function (table, index) {
                    return _c(
                      "div",
                      {
                        key: _vm.item,
                        staticClass: "icon-l",
                        class: {
                          "btn-primary": index == _vm.tableIndexSelected,
                        },
                        on: {
                          click: function ($event) {
                            _vm.tableIndexSelected = index
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(table.label || table.name) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "container-custom-table",
                style: { height: (_vm.maxRows + 1) * 45 + "px" },
              },
              [
                _c("div", { staticClass: "custom-table" }, [
                  _c("table", [
                    _c("thead", [
                      _c(
                        "tr",
                        _vm._l(
                          _vm.tables[_vm.tableIndexSelected].columns,
                          function (column) {
                            return _c("th", { key: column.key }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(column.label) +
                                  "\n                            "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.tables[_vm.tableIndexSelected].data,
                        function (row, rowIndex) {
                          return _c(
                            "tr",
                            { key: rowIndex },
                            _vm._l(
                              _vm.tables[_vm.tableIndexSelected].columns,
                              function (column) {
                                return _c(
                                  "td",
                                  {
                                    key: column.key,
                                    style: {
                                      color: column.dataColor
                                        ? column.dataColor
                                        : "#696D76",
                                      fontWeight: column.dataFontWeight
                                        ? column.dataFontWeight
                                        : "500",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          row[column.key]
                                            ? row[column.key]
                                            : "\u00A0\u00A0-"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }